module.exports = __webpack_public_path__ + "img/xiaochengxu.a7d0b512.jpg";